<nav role="navigation">
    <!-- the inline-block class is to make sure that ul is not 100% wide (for off click in icms) -->
    <ul class="inline-block"
        (offClick)="closeMeganav()"
        [offClickFilter]="'page-header-meganav-content-item, icms-admin-editor'">
        @for (item of items; track item) {
        <li class="inline-block m-l-10">
            <href [link]="client.isCms && item.columns?.length ? undefined : item.link"
                  (mouseenter)="onMouseIn($index)"
                  (mouseout)="onMouseOut($index)"
                  (click)="onClick($index)"
                  [toggleClass]="'_revealed'"
                  [toggleClassBy]="[toggleGroupId, $index]">
                <span #link
                      class="s1 col-11 _link"
                      [style.--width.px]="getWidth($index) || 0"
                      *iCms="'text' of item"
                      cy-navigationlink></span>
            </href>
        </li>
        }
    </ul>
</nav>